import { PageBreak } from "app/components/layout/PageBreak";

import { ConversionRateOverviewContainer } from "../../widgets/conversion-rate/ConversionRateOverviewContainer";
import { ConversionRateLeaders } from "../../widgets/conversion-rate/single/leaders/ConversionRateLeaders";
import { DeviceDistributionChart } from "../../widgets/device-distribution/single/DeviceDistributionChart/DeviceDistributionChart";
import { HighLevelMetricsOvertime } from "../../widgets/high-level-metrics/single/HighLevelMetricsOvertime";
import KeyIndicatorsContainer from "../../widgets/key-indicators/single/KeyIndicatorsContainer";
import { MarketSize } from "../../widgets/marketSize/single/MarketSize";
import { TopCountries } from "../../widgets/top-countries/single/TopCountries";
import { TopPlayers } from "../top-players/TopPlayers";

import {
    MarketShareSectionTitle,
    MarketSizeAndIndicatorsContainer,
    MarketSizeSectionTitle,
    PageContainer,
} from "./styled";

export const MarketResearchOverviewAll = () => {
    return (
        <PageContainer>
            <MarketSizeSectionTitle />
            <MarketSizeAndIndicatorsContainer>
                <MarketSize />
                <KeyIndicatorsContainer />
            </MarketSizeAndIndicatorsContainer>
            <HighLevelMetricsOvertime />
            <PageBreak applyPageBreak />
            <ConversionRateOverviewContainer />
            <ConversionRateLeaders />

            <MarketShareSectionTitle />
            <TopPlayers />
            <DeviceDistributionChart />
            <TopCountries />
        </PageContainer>
    );
};
